import { useTranslation } from '../../../i18n/useTranslation';
import { getBuyerContacts } from '../../../components/shopping-cart/services/shopping-cart.service';
import { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';

import {
    Dialog,
    DialogContent,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
    IconButton,
    Stack,
    Pagination,
} from '@mui/material';
import BuildingSitesListSkeleton from '../../building-sites-list/building-sites-list-skeleton';
import { IBuyerContactListView } from '../../../components/order/interfaces/buyer-contact-list-view.interface';
import { IPaginatedList } from '../../../shared/models/paginated-list.interface';

interface Prop {
    isOpen: boolean;
    handleCloseDialog: Function;
    selectedBuildingSiteUuid: string;
}

const BuildingSitesDeliveryContactSelector: React.FC<Prop> = ({
    isOpen,
    selectedBuildingSiteUuid,
    handleCloseDialog,
}) => {
    const { t } = useTranslation('translation');
    const [page] = useState<number>(1);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [buyerContacts, setBuyerContacts] = useState<IBuyerContactListView[]>([]);

    const handleClose = (selectedBuyerContact: IBuyerContactListView | null) => {
        handleCloseDialog(selectedBuyerContact);
    };

    const getAndSetBuyerContacts = (page: number) => {
        setIsLoading(true);
        getBuyerContacts(selectedBuildingSiteUuid, page).then((response) => {
            if (response) {
                const data: IBuyerContactListView[] = response.data;
                setBuyerContacts(data);
                setIsLoading(false);
            } else {
                setIsLoading(false);
            }
        });
    };

    useEffect(() => {
        getAndSetBuyerContacts(page);
    }, []);

    return (
        <div>
            <Dialog open={isOpen} onClose={() => handleClose(null)} fullWidth maxWidth="md">
                <DialogContent sx={{ position: 'relative' }}>
                    <Typography variant="h6" gutterBottom>
                        {t('SELECT_DELIVERY_CONTACT')}
                    </Typography>
                    <IconButton
                        onClick={() => {
                            handleClose(null);
                        }}
                        sx={{
                            position: 'absolute',
                            top: 8,
                            right: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>

                    {isLoading ? (
                        <BuildingSitesListSkeleton count={3} />
                    ) : (
                        <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell
                                            sx={{ position: 'sticky', top: 0, backgroundColor: '#f5f5f5', zIndex: 1 }}
                                        >
                                            <strong>{t('FIRST_NAME')}</strong>
                                        </TableCell>
                                        <TableCell
                                            sx={{ position: 'sticky', top: 0, backgroundColor: '#f5f5f5', zIndex: 1 }}
                                        >
                                            <strong>{t('LAST_NAME')}</strong>
                                        </TableCell>
                                        <TableCell
                                            sx={{ position: 'sticky', top: 0, backgroundColor: '#f5f5f5', zIndex: 1 }}
                                        >
                                            <strong>{t('PHONE')}</strong>
                                        </TableCell>
                                        <TableCell
                                            sx={{ position: 'sticky', top: 0, backgroundColor: '#f5f5f5', zIndex: 1 }}
                                        >
                                            <strong>{t('EMAIL')}</strong>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {buyerContacts.map((item) => (
                                        <TableRow
                                            onClick={() => {
                                                handleClose(item);
                                            }}
                                            key={item.id}
                                            sx={{
                                                '&:hover': {
                                                    backgroundColor: '#f2f2f2',
                                                    cursor: 'pointer',
                                                },
                                            }}
                                        >
                                            <TableCell sx={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>
                                                {item.firstName}
                                            </TableCell>
                                            <TableCell sx={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>
                                                {item.lastName}
                                            </TableCell>
                                            <TableCell sx={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>
                                                {item.phone}
                                            </TableCell>
                                            <TableCell sx={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>
                                                {item.email}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}
                </DialogContent>
            </Dialog>
        </div>
    );
};
export default BuildingSitesDeliveryContactSelector;
